import { gql } from '@apollo/client'

export default gql`
  query SellerLeadIndicationSummary {
    sellerLeadSummary {
      title
      count
      leadStatus
      subtotals {
        title
        count
      }
    }
  }
`
